// Global
import React from 'react';

// Local
import { ProductResponse } from 'lib/services/models/content-response';

import styles from './ProductDescription.module.scss';
import EnhancedRichText from 'components/helpers/Atoms/EnhancedRichText/EnhancedRichText';
import useDictionary from 'lib/hooks/useDictionary';

export interface ProductDescriptionProps {
  product?: ProductResponse;
}

export function ProductDescription(props: ProductDescriptionProps) {
  const product = props.product;
  const { getDictionaryValue } = useDictionary();

  if (!product) {
    return <></>;
  }

  if (!product.Description) {
    return <></>;
  }

  return (
    <div>
      <div className={styles.productDescriptionWrapper}>
        <h2 className={styles.productDescriptionHeading}>
          {getDictionaryValue('Components.Product.ProductDescription.ProductDescriptionHeadline') ||
            'Product Description'}
        </h2>
        <EnhancedRichText
          className={styles.productDescriptionContent}
          value={product.Description}
        />
      </div>
    </div>
  );
}
